<div class="attachmentCont">
  @if (!useImageColumn) {
    <app-attachment-collage [attachments]="attachments.images" (getThumb)="getThumb.emit($event)">
    </app-attachment-collage>
  }
  @if (useImageColumn) {
    <app-attachment-image-column
      [attachments]="attachments.images"
      (getFull)="getFull.emit($event)"
    (imageSelected)="imageSelected.emit($event)"></app-attachment-image-column>
  }
</div>

<div class="attachmentCont">
  @for (attachment of attachments.documents; track attachment) {
    <app-document-attachment
      [attachment]="attachment"
    (openAttachment)="openAttachment.emit($event)"></app-document-attachment>
  }
</div>
